import React from 'react'
import './NavigationItems.css'
import NavigationItem from './NavigationItem/NavigationItem'


        const NavigationItems = (props) => {
    const token = window.localStorage.getItem("token")
    const login = (event) => {
        props.login(event)
    }
    return (
            <div className="mainMenu">
                {token == null || token == '' ? <div className="Login" onClick={(event) => login(event)}>ورود</div> : ''}
                <NavigationItem closeSideBar={(event) => props.closeSideBar(event)} link="/" exact >خانه</NavigationItem>
                <NavigationItem closeSideBar={(event) => props.closeSideBar(event)} link="/third-policy" >ثبت سفارش</NavigationItem>
                <NavigationItem closeSideBar={(event) => props.closeSideBar(event)} link="/record-order" >ثبت سفارش صوتی</NavigationItem>
                <NavigationItem closeSideBar={(event) => props.closeSideBar(event)} link="/faq" >سوالات متداول</NavigationItem>
                <NavigationItem closeSideBar={(event) => props.closeSideBar(event)} link="/about-us" >درباره ما</NavigationItem>
            </div>

            )
}

export default NavigationItems